import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

// mui material
import {
    Box,
    Tab,
    Tabs
} from '@mui/material';
import Grid from '@mui/system/Unstable_Grid/Grid';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import Face6Icon from '@mui/icons-material/Face6';
import { useTheme } from '@mui/material/styles';

// project import
import { gridSpacing, USER_TYPE } from 'store/constant';
import MainCard from 'ui-component/cards/MainCard';
import UserTab from './UserTab';

// tabs option
const tabsOption = [
    { label: 'Customers', icon: <Face6Icon sx={{ fontSize: '1.3rem' }} /> },
    { label: 'Managers', icon: <ManageAccountsIcon sx={{ fontSize: '1.3rem' }} /> }
];

// tabs panel
function TabPanel({ children, value, index, ...other }) {
    return (
        <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
            {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
        </div>
    );
}
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired
};
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`
    };
}

export const Users = () => {

    const theme = useTheme();
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <MainCard>
            <Grid container spacing={gridSpacing}>
                <Grid item xs={12}>
                    <Tabs
                        value={value}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={handleChange}
                        aria-label="simple tabs example"
                        variant="scrollable"
                        sx={{
                            mb: 3,
                            '& a': {
                                minHeight: 'auto',
                                minWidth: 10,
                                py: 1.5,
                                px: 1,
                                mr: 2.25,
                                color: theme.palette.mode === 'dark' ? 'grey.600' : 'grey.550',
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'center'
                            },
                            '& a.Mui-selected': {
                                color: theme.palette.primary.main
                            },
                            '& .MuiTabs-indicator': {
                                bottom: 2
                            },
                            '& a > svg': {
                                marginBottom: '0px !important',
                                mr: 1.25
                            }
                        }}
                    >
                        {tabsOption.map((tab, index) => (
                            <Tab key={index} component={Link} to="#" icon={tab.icon} label={tab.label} {...a11yProps(index)} />
                        ))}
                    </Tabs>
                    <TabPanel value={value} index={0}>
                        <UserTab userType={USER_TYPE[1].value} />
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <UserTab userType={USER_TYPE[0].value} />
                    </TabPanel>
                </Grid>
            </Grid>
        </MainCard>
    );
};
